import { Version } from "../../types/entities/version";
import { getStore } from "../store/appStore";
import { AppAction } from "../types";
import { VersionActionKey as ActionKey } from "./ActionKeys";

export interface FetchVersionsSuccessAction
  extends AppAction<
    ActionKey.FETCH_VERSIONS_SUCCESS,
    { id: number; versions: Version[] }
  > {}
interface FetchVersionsFailureAction
  extends AppAction<
    ActionKey.FETCH_VERSIONS_FAILURE,
    { id: number; error: string }
  > {}
interface FetchVersionsStartedAction
  extends AppAction<ActionKey.FETCH_VERSIONS_STARTED> {}

export type VersionsAction =
  | FetchVersionsStartedAction
  | FetchVersionsSuccessAction
  | FetchVersionsFailureAction;

export const fetchVersionsStarted = (): FetchVersionsStartedAction =>
  getStore().dispatch({ type: ActionKey.FETCH_VERSIONS_STARTED, payload: {} });

export const fetchVersionsSuccess = (
  id: number,
  versions: Version[]
): FetchVersionsSuccessAction =>
  getStore().dispatch({
    type: ActionKey.FETCH_VERSIONS_SUCCESS,
    payload: { id, versions },
  });

export const fetchVersionsFailure = (
  id: number,
  error: string
): FetchVersionsFailureAction =>
  getStore().dispatch({
    type: ActionKey.FETCH_VERSIONS_FAILURE,
    payload: { id, error },
  });
